// Libs
import composeOperator from 'fc-operations'

// Exports
export default composeOperator({
  model: 'FEATURE',
  branch: 'featureOperations',
})
